import React from "react";
import { clsx } from "clsx";

const SectionHeading = ({
  subtitle,
  title,
  textAlign = "center",
  containerClassName,
  subtitleClassName,
  titleClassName,
  spacing = "default",
}) => {
  // Base container styles
  const containerBaseStyles = clsx(
    "w-full flex flex-col",
    {
      "items-start text-left": textAlign === "left",
      "items-center text-center": textAlign === "center",
      "items-end text-right": textAlign === "right",
    },
    {
      "gap-1": spacing === "tight",
      "gap-2": spacing === "default",
      "gap-3": spacing === "loose",
    }
  );

  // Base subtitle styles
  const subtitleBaseStyles = clsx(
    "font-poppins font-medium capitalize align-middle transition-all duration-200",
    "text-[#29AAE1] tracking-[0.125rem]", // 2px = 0.125rem
    // Mobile first
    "text-[0.875rem] leading-[1.125rem]", // 14px / 18px
    // Tablets
    "sm:text-[1rem] sm:leading-[1.25rem]", // 16px / 20px
    // Medium screens
    "md:text-[1.125rem] md:leading-[1.375rem]", // 18px / 22px
    // Large screens
    "lg:text-[1.25rem] lg:leading-[1.5rem]" // 20px / 24px
    // XL screens
    // "xl:text-[1.375rem] xl:leading-[1.625rem]" // 22px / 26px
  );

  // Base title styles
  const titleBaseStyles = clsx(
    "font-dm-sans font-semibold capitalize text-[#08121A] align-middle transition-all duration-300 tracking-[0.0625rem]", // 1px = 0.0625rem
    // Mobile first
    "text-[1.75rem] leading-[2.25rem]", // 28px / 36px
    // Tablets
    "sm:text-[2rem] sm:leading-[2.5rem]", // 32px / 40px
    // Medium screens
    "md:text-[2.25rem] md:leading-[2.75rem]", // 36px / 44px
    // Large screens
    "lg:text-[2.8125rem] lg:leading-[3.1875rem]" // 45px / 51px
    // XL screens
    //  "xl:text-[3.4375rem] xl:leading-[3.875rem]" // 55px / 62px
  );

  // Merge with custom classes
  const finalContainerClasses = clsx(containerBaseStyles, containerClassName);
  const finalSubtitleClasses = clsx(subtitleBaseStyles, subtitleClassName);
  const finalTitleClasses = clsx(titleBaseStyles, titleClassName);

  return (
    <div
      className={finalContainerClasses}
      data-aos="fade-up"
      data-aos-duration="400"
    >
      <h3
        className={finalSubtitleClasses}
        data-aos="fade-down"
        data-aos-delay="100"
      >
        {subtitle}
      </h3>
      <h1 className={finalTitleClasses} data-aos="fade-up" data-aos-delay="200">
        {title}
      </h1>
    </div>
  );
};

export default SectionHeading;
